import { BehaviorSubject, Subject } from 'rxjs';
export const user$ = new BehaviorSubject(null);
export const userSettings$ = new BehaviorSubject(null);
export const sseRefresh$ = new Subject();
//# sourceMappingURL=store-user.js.map